import partnershipsContext from '@partnershipsContext/i18n/ru.json';

import RU from '../constants/ru.json';

const localeTextTranslationsRu = {
  ...RU,
  ...partnershipsContext,
};

export default localeTextTranslationsRu;
